export default __webpack_public_path__ + "static/media/jobless.17e22cb8.jpg";